export const checkResponseStatus = (response: any) => {
  if (!response.status || response.status !== 'OK') {
    throw new Error(`Response error, status: ${response.status}`);
  }
};
